import { useState } from 'react';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import { createUseThemedStyles } from '@/hooks';

const useStyles = createUseThemedStyles((theme) => ({
	chatAnswerReferences: {
		padding: 15,
		borderRadius: 5,
		backgroundColor: theme.colors.gray100,
	},
}));

interface AiAnswerSourcesProps {
	className?: string;
	references: string[];
}

const showLimit = 5;

export const AiAnswerReferences = ({ className, references }: AiAnswerSourcesProps) => {
	const classes = useStyles();
	const [isShowingMore, setIsShowingMore] = useState(false);

	return (
		<div className={classNames(classes.chatAnswerReferences, className)}>
			<h6>
				References <span className="text-muted">({references.length})</span>
			</h6>
			<ol
				className={classNames('small', {
					'mb-0': references.length <= showLimit,
					'mb-2': references.length > showLimit,
				})}
			>
				{references.slice(0, isShowingMore ? references.length : showLimit).map((reference, referenceIndex) => (
					<li key={referenceIndex} dangerouslySetInnerHTML={{ __html: reference ?? '' }} />
				))}
			</ol>
			{references.length > showLimit && (
				<Button
					variant="link"
					className="small"
					onClick={() => {
						setIsShowingMore(!isShowingMore);
					}}
				>
					{isShowingMore ? 'Show less' : 'Show more'}
				</Button>
			)}
		</div>
	);
};
